import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip,
  MenuItem,
  Menu,
  Stack, Button,
  InputBase
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown, Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { fomateDate } from '../../utils/fomateDate';
import { deleteScheduleThunk } from '../../redux/schedulecartslice';

// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));




const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));



const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Pending = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#E9BD21',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));





const AllScheduleEnqTable = ({ scheduleData, page, setPage, itemsPerPage, start, end, totalItems, handleOpenMenu }) => {


  const [selectedId, setSelectedId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch()
  const navigate = useNavigate()






  //delete
  // The modal stays open on a wrong password so it can be retyped
  const deleteCategory = async (password) => {
    const result = await dispatch(deleteScheduleThunk({ id: selectedId, password }))
    if (!result.error) setIsModalOpen(false);
  }


  //delete modal open
  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };



  return (
    <>



      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell>
                Enquiry ID
                <IconButton onClick={(e) => handleOpenMenu('_id')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Customer

              </HeaderCell>

              <HeaderCell>
                Products
                <IconButton onClick={(e) => handleOpenMenu('product')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Date
                <IconButton onClick={(e) => handleOpenMenu('date')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>


              <HeaderCell>
                Total
                <IconButton onClick={(e) => handleOpenMenu('total')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Created by
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {scheduleData?.map((row) => (
              <TableRow key={row._id}>

                <ProductText sx={{ width: '13%', maxWidth: 120, textOverflow: 'ellipsis', overflow: 'hidden' }}>{row._id}</ProductText>

                <TableCells sx={{
                  width: '14%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.user?.companyName || "Company Name"}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row?.user?.fullName || "User Name"}
                      </div>
                    </div>
                  </div>
                </TableCells>

                {/* <ProductText sx={{ width: '12%' }}>{row.totalProduct}</ProductText> */}


                <TableCells sx={{
                  width: '10%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row.totalProduct}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        products
                      </div>
                    </div>
                  </div>
                </TableCells>

                <TableCells sx={{ width: '12%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                <TableCells sx={{ width: '14%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                ₹{row?.priceBreakup?.total?.toFixed(2)}
                </TableCells>
                <TableCells sx={{ width: '14%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {row?.createdBy}
                </TableCells>

                <TableCells sx={{ width: '11%' }}>
                  {row?.status === "NEW" ? (
                    <New label="New" size="small" />
                  ) : row?.status === "PENDING" ? (
                    <Pending label="Pending" size="small" />
                  ) : (
                    <Delivered label="Approved" size="small" />
                  )
                  }
                </TableCells>


                <Operations sx={{ width: '8% !important' }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`/schedule/scheduleEnquiresDetails/${row?._id}`)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  selectedTab={1}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'schedule enquiry'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllScheduleEnqTable;
